// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__KXyvv","signatureButtonsRight":"ModalSign_signatureButtonsRight__KY88b"};